import React from 'react';
import StandardsReportRouter from '../containers/StandardsReportRouter';

export default (props) => (
  <StandardsReportRouter {...props} />
);
